import { Link } from 'react-router-dom';
import { useScrollReveal } from '@/hooks/useScrollReveal';

export default function SubscriptionTeaser() {
  const { ref, revealed } = useScrollReveal();

  return (
    <section className="py-16 md:py-20 bg-gradient-to-r from-accent-50 via-background-50 to-accent-50">
      <div ref={ref} className={`container-page scroll-reveal ${revealed ? 'revealed' : ''}`}>
        <div className="flex flex-col lg:flex-row items-center gap-10 md:gap-16">
          {/* Text */}
          <div className="flex-1 text-center lg:text-left">
            <span className="inline-block text-xs font-semibold text-accent-600 uppercase tracking-widest mb-4">
              Subscribe & Save
            </span>
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-primary-700 mb-4">
              Never Run Out of Kitchen Essentials
            </h2>
            <p className="text-foreground-500 max-w-xl leading-relaxed mb-6">
              Set up recurring orders for your most-used products — choose weekly, fortnightly or monthly delivery. Pause, skip or cancel anytime. Plus, subscribers get 10% off every order and early access to seasonal specials.
            </p>
            <Link
              to="/retail"
              className="inline-flex items-center gap-2 px-8 py-3.5 bg-accent-500 hover:bg-accent-400 text-brand-800 font-semibold text-sm rounded-lg transition-all whitespace-nowrap cursor-pointer"
            >
              Explore Subscriptions
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>

          {/* Visual */}
          <div className="flex-1 max-w-md hidden lg:block">
            <div className="group bg-card-50 rounded-2xl p-6 border border-card-200 shadow-sm">
              <div className="flex items-center gap-4 mb-5">
                <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-accent-50 text-accent-600 animate-icon-float icon-hover-pop">
                  <i className="ri-repeat-line text-xl"></i>
                </div>
                <div>
                  <h4 className="font-heading text-base font-bold text-primary-700">Weekly Essentials Plan</h4>
                  <p className="text-xs text-foreground-400">Most popular subscription</p>
                </div>
              </div>
              <div className="space-y-3 mb-5">
                {['Chicken Breast 1kg × 2', 'Green Peas 1kg × 1', 'Basa Fillet 1kg × 1', 'Mixed Vegetables 500g × 2'].map((item) => (
                  <div key={item} className="flex items-center justify-between text-sm">
                    <span className="text-foreground-600">{item}</span>
                    <span className="w-2 h-2 rounded-full bg-secondary-500"></span>
                  </div>
                ))}
              </div>
              <div className="border-t border-background-200/70 pt-4 flex items-center justify-between">
                <span className="font-heading text-lg font-bold text-primary-700">₹1,296<span className="text-xs text-foreground-400 font-normal">/week</span></span>
                <span className="text-xs text-accent-600 font-semibold bg-accent-50 px-2.5 py-1 rounded-full">Save 10%</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}